// extracted by mini-css-extract-plugin
export default {"header":"copiesOdDoc_header__0jUTe"};